<script>
export default {
  name: "franchise-earn",
  props: ['view'],
  data() {
    return {
      showUsd: true,
      showBrl: true,
      showEur: true,
      showCzk: false,
      showThb: false,
      showInr:  false,
      t: null,
      loading: true,
      propView: null,
      currentPage: 0,
      totalPage: 0,
      totalItems: 0,
      dataTable: [],

      quickFilter: [],
      oldQuickFilter: [],
      showModalFilter: false,
      isEqualFilter: true,
      searchValue: ''
    }
  },
  created() {
    this.t = this.view[0].translations
    this.showCzk = this.view[0].card['A_RECEBER']['CZK'] > 0 || this.view[0].card['NAO']['CZK'] > 0 || this.view[0].card['SOLICITADO']['CZK'] > 0 || this.view[0].card['SIM']['CZK'] > 0 ? true : false
    this.showThb = this.view[0].card['A_RECEBER']['THB'] > 0 || this.view[0].card['NAO']['THB'] > 0 || this.view[0].card['SOLICITADO']['THB'] > 0 || this.view[0].card['SIM']['THB'] > 0 ? true : false
    this.showInr = this.view[0].card['A_RECEBER']['INR'] > 0 || this.view[0].card['NAO']['INR'] > 0 || this.view[0].card['SOLICITADO']['INR'] > 0 || this.view[0].card['SIM']['INR'] > 0 ? true : false
  },
  mounted() {
    console.log(this.view)
    this.propView = this.view[0]
    this.requestTable()
    this.quickFilter = this.mountQuickFilter()
    this.oldQuickFilter = this.mountQuickFilter()
    document.addEventListener('click', this.handleClickOutside)

    this.openRequesEarningsModal()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    openRequesEarningsModal() {
      const url = new URL(window.location.href);
      const openmodal = url.searchParams.get('openmodal');

      if (!isEmpty(openmodal) && openmodal == 'requestEarnings') {
        setTimeout(() =>{
          $('#solicitarSaqueModal').modal('show')
        }, 2000)
      }
    },
    requestTable(isSearch = false) {
      this.loading = true
      let route = '/' + this.propView.lang + '/office/franchise-system/paginated-earnings?data-type=json'

      if (isSearch) {
        this.dataTable = []
      }
      if (!isEmpty(this.quickFilter) || isSearch) {
        route = route +
          '&f_filterby='         + this.searchValue +
          '&f_status='          + this.quickFilter[0].filter +
          '&f_type='            + this.quickFilter[1].filter +
          '&f_tipo_fatura='     + this.quickFilter[2].filter +
          '&f_plan='            + this.quickFilter[3].filter +
          '&f_purchased_date='  + this.quickFilter[4].filter +
          '&page='              + this.currentPage;
      }

      axios
        .get(route)
        .then((response) => {
          if (!isEmpty(response.data.paginated_earnings)) {
            this.dataTable.push({page: this.currentPage, data: response.data.paginated_earnings});
          } else [
            this.dataTable = []
          ]

          this.currentPage                   = response.data['current_page'];
          this.totalItems                    = response.data['total_items'];
          this.totalPage                     = response.data['total_pages'];
        })
        .catch(e => {
          console.error('error on get table data', e)
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 500)
          console.log(this.$data)
        });
    },
    IsEmpty(val) {
      return isEmpty(val)
    },
    getPercentComission(planValue, comission) {
      return ((comission / planValue) * 100).toFixed(2) + '%'
    },
    currencySymbol (currency) {
      return {
        brl: 'R$',
        usd: '$',
        eur: '€',
        gbp: '£',
        czk: 'Kč',
        inr: '&#8377',
        thb: '฿',
      }[currency.toLowerCase()]
    },
    checkCached() {
      let indexPage = this.dataTable.findIndex(x => x.page === this.currentPage)

      if (indexPage == -1) {
        this.requestTable()
      }
    },
    mountQuickFilter() {
      return [
        { title: this.t['status'], select: this.statusSelect, showFilter: false, filter: '', mouseLeave: false },
        { title: this.t['office2_ganhos_tipo'], select: this.typeSelect, showFilter: false, filter: '', mouseLeave: false },
        { title: this.t['franquia_faturas_tipo'], select: this.faturaType, showFilter: false, filter: '', mouseLeave: false },
        { title: 'Plans', select: this.view[0].plansFilter, showFilter: false, filter: '', mouseLeave: false },
        { title: 'Date', select: this.view[0].dateFilter, showFilter: false, filter: '', mouseLeave: false },
      ]
    },
    getDataPageIndex() {
      return this.dataTable.findIndex(x => x.page === this.currentPage)
    },
    dispatchRequest() {
      if (!this.isEqualFilter) {
        this.dataTable = []
        this.requestTable()
      }
    },
    openFilterSelect(i) {
      this.quickFilter.forEach((obj, index) => {
        obj.showFilter = index === i;
      });
    },
    handleClickOutside(event) {
      const outerModal = this.$refs.outerModal;
      const innerModals = this.$refs.innerModal;

      let clickedOutsideOuter = true;
      let clickedOutsideAllInner = true;

      // Verifica se o clique foi dentro do modal externo
      if (outerModal && outerModal.contains(event.target)) {
        clickedOutsideOuter = false;
      }

      // Verifica se o clique foi dentro de qualquer modal interno
      if (innerModals) {
        innerModals.forEach(modal => {
          if (modal.contains(event.target)) {
            clickedOutsideAllInner = false;
          }
        });
      }

      // Se o clique for fora do modal externo, feche ambos os modais
      if (clickedOutsideOuter) {
        this.quickFilter.forEach(filter => {
          filter.showFilter = false;
        });
        this.showModalFilter = false
      }

      // Se o clique for fora do modal interno, feche apenas o modal interno
      if (clickedOutsideAllInner) {
        this.quickFilter.forEach(filter => {
          filter.showFilter = false;
        });
      }
    },
    getSelectIndex(badge) {
      return badge.select.findIndex(x => x.value === badge.filter);
    },
    async clearFilter(filter) {
      await this.quickFilter.forEach(x => {
        if (isEmpty(filter) || filter == x.filter) {
          x.filter = ''
        }
      })
      if (isEmpty(filter)) {
        this.searchValue = ''
      }
      this.dataTable = []
      this.requestTable()
    },
    open(data) {
      if(data == 1) {
        $('#setupEwalltet').modal('show');
      } else if(data == 2) {
        window.open(this.view[0].get_paid_btns.btn_conditions.url_access_ewallet);
      } else {
        $('#solicitarSaqueModal').modal('show');
      }
    },
    getTooltipData(item) {
      let tooltip = item.data.status.title

      if (!isEmpty(item.data.status.date)) {
        tooltip += ` ${item.data.status.date}`
      }

      return tooltip
    }
  },
  computed: {
    cards() {
      return [
        {
          title: this.view[0].translations['fs5_on_hold'],
          icon: 'clock',
          items: [
            {type: 'USD', show: this.showUsd, symbol: '$',  value: this.view[0].card['A_RECEBER']['USD']},
            {type: 'EUR', show: this.showEur, symbol: '€',  value: this.view[0].card['A_RECEBER']['EUR']},
            {type: 'BRL', show: this.showBrl, symbol: 'R$', value: this.view[0].card['A_RECEBER']['BRL']},
            {type: 'CZK', show: this.showCzk, symbol: 'Kč', value: this.view[0].card['A_RECEBER']['CZK']},
            {type: 'THB', show: this.showThb, symbol: '฿',  value: this.view[0].card['A_RECEBER']['THB']},
            {type: 'INR', show: this.showInr, symbol: '₹',  value: this.view[0].card['A_RECEBER']['INR']}
          ],
        },
        {
          title: this.view[0].translations['office2_ganhos_disponivel'],
          icon: '3791',
          items: [
            {type: 'USD', show: this.showUsd, symbol: '$', value: this.view[0].card['NAO']['USD']},
            {type: 'EUR', show: this.showEur, symbol: '€', value: this.view[0].card['NAO']['EUR']},
            {type: 'BRL', show: this.showBrl, symbol: 'R$', value: this.view[0].card['NAO']['BRL']},
            {type: 'CZK', show: this.showCzk, symbol: 'Kč', value: this.view[0].card['NAO']['CZK']},
            {type: 'THB', show: this.showThb, symbol: '฿', value: this.view[0].card['NAO']['THB']},
            {type: 'INR', show: this.showInr, symbol: '₹', value: this.view[0].card['NAO']['INR']}
          ]
        },
        {
          title: this.view[0].translations['office2_ganhos_solicitado'],
          icon: 'requested',
          items: [
            {type: 'USD', show: this.showUsd, symbol: '$', value: this.view[0].card['SOLICITADO']['USD']},
            {type: 'EUR', show: this.showEur, symbol: '€', value: this.view[0].card['SOLICITADO']['EUR']},
            {type: 'BRL', show: this.showBrl, symbol: 'R$', value: this.view[0].card['SOLICITADO']['BRL']},
            {type: 'CZK', show: this.showCzk, symbol: 'Kč', value: this.view[0].card['SOLICITADO']['CZK']},
            {type: 'THB', show: this.showThb, symbol: '฿', value: this.view[0].card['SOLICITADO']['THB']},
            {type: 'INR', show: this.showInr, symbol: '₹', value: this.view[0].card['SOLICITADO']['INR']}
          ],
        },
        {
          title: this.view[0].translations['office2_ganhos_pago'],
          icon: 'money-bag',
          items: [
            {type: 'USD', show: this.showUsd, symbol: '$', value: this.view[0].card['SIM']['USD']},
            {type: 'EUR', show: this.showEur, symbol: '€', value: this.view[0].card['SIM']['EUR']},
            {type: 'BRL', show: this.showBrl, symbol: 'R$', value: this.view[0].card['SIM']['BRL']},
            {type: 'CZK', show: this.showCzk, symbol: 'Kč', value: this.view[0].card['SIM']['CZK']},
            {type: 'THB', show: this.showThb, symbol: '฿', value: this.view[0].card['SIM']['THB']},
            {type: 'INR', show: this.showInr, symbol: '₹', value: this.view[0].card['SIM']['INR']}
          ],
        },
      ]
    },
    pagesList() {
      const totalPages = this.totalPage;
      const currentPage = this.currentPage;

      const lastFourPages = [totalPages - 3, totalPages - 2, totalPages - 1, totalPages]
        .filter(page => page > 0 && page <= totalPages);

      let firstTwoPages = [];
      let lastTwoPages = [totalPages - 1, totalPages];

      const isInLastFour = lastFourPages.includes(currentPage);

      if (isInLastFour) {
        firstTwoPages = lastFourPages.slice(0, 2);
        lastTwoPages = lastFourPages.slice(2);
      } else {
        firstTwoPages = [currentPage, currentPage + 1].filter(page => page > 0 && page <= totalPages);
      }

      lastTwoPages = lastTwoPages.filter(page => page > 0 && page <= totalPages);

      return {
        firstTwoPages: firstTwoPages,
        lastTwoPages: lastTwoPages,
        isInLastFour: isInLastFour
      };
    },
    statusSelect() {
      return [
        { title: this.t['status'], value: '' },
        { title: this.t['label_aguardando_liberacao'], value: 'a_receber' },
        { title: this.t['office2_ganhos_disponivel'], value: 'disponivel' },
        { title: this.t['label_devolvido'], value: 'reembolsado' },
        { title: this.t['office2_ganhos_pago'], value: 'pago' },
      ]
    },
    typeSelect() {
      return [
        { title: this.t['office2_ganhos_tipo'], value: '' },
        { title: this.t['commission-label-direct-sale'], value: 'direct-sale' },
        { title: this.t['commission-label-level'].replace("%s", "1"), value: 'level-1' },
        { title: this.t['commission-label-ambassador'], value: 'ambassador' },
        { title: this.t['commission-label-venda-direta-concessao'], value: 'venda_direta_concessao' },
        { title: this.t['commission-label-saldo_concessao'], value: 'saldo_concessao' },
        { title: this.t['commission-label-network'], value: 'network' },
      ]
    },
    faturaType() {
      return [
        { title: this.t['franquia_faturas_tipo'], value: '' },
        { title: this.t['standard'], value: 'normal' },
        { title: this.t['title_office_franquia'], value: 'franquia' },
      ]
    },
    buttonAvailable () {
      let buttons = []
      var i = 0
      if (this.view[0].get_paid_btns.btn_conditions.showEwallet) {
        if (!this.view[0].get_paid_btns.btn_conditions.ipayout_username)
        {
          buttons[i] = {description: this.view[0].get_paid_btns.btn_translation.label_setup_ewallet, btn: 1, status: false, class: 'ba-blue', tooltip: ''}
          i++
        }
        else
        {
          buttons[i] = {description: this.view[0].get_paid_btns.btn_translation.label_access_ewallet, btn: 2, status: false, class: 'ba-blue', tooltip: ''}
          i++
        }
      }
      buttons[i] = {description: this.view[0].get_paid_btns.btn_translation.office2_ganhos_solicitacao_saque, btn: 3, status: this.view[0].get_paid_btns.btn_conditions.disable_btn_saque, class: 'ba-light', tooltip: this.view[0].get_paid_btns.btn_translation.withdrawal_request_tooltip}
      i++
      return  buttons
    }
  },
  watch: {
    searchValue(newVal) {
      if (newVal.length == 0) {
        this.dataTable = []
        this.requestTable()
      }
    },
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkCached()
      }
    },
    quickFilter: {
      handler(newVal, oldVal) {
        this.isEqualFilter = isEqual(newVal, this.oldQuickFilter, 'showFilter')
        this.oldQuickFilter = JSON.parse(JSON.stringify(newVal));
      },
      deep: true
    }
  }
}
</script>

<template>
  <div class='franchise-grid'>
    <div class='ba-card-breadcrumb ba-card'>
      <nav class='ba-breadcrumb'>
        <ol class='ba-breadcrumb-ol'>
          <li class='ba-breadcrumb-item ba-main-item'>
            <a href='#'>
              <builderall-icon code='house' />
            </a>
          </li>
          <li class='ba-breadcrumb-item'>
            <a href='#'>{{ t.earnings }}</a>
          </li>
        </ol>
      </nav>
    </div>

    <fs5-earnings-notice :view="view[0]" :t="t" />

    <div class='ba-card ba-w-100'>
      <div class='ba-top'>
        <div class='ba-flex ba-f-column'>
          <span class='ba-title'>{{ t.my_current_earnings }}</span>
        </div>
        <div class='ba-box-items ba-flex ba-gp-1'>
          <button class='ba-btn ba-md btn-current-earnings'
                  v-for="(value, index) in buttonAvailable"
                  :key="index"
                  :class="value.class"
                  target="_blank"
                  @click="open(value.btn)"
                  :disabled="value.status"
                  ba-tooltip-position='bottom'
                  :ba-tooltip-title="value.tooltip || null"
          >{{ value.description }}</button>
        </div>
      </div>
      <div class='ba-content'>
        <div v-for='(card, index) in cards' :key='index'
             class='ba-card'>
          <div class="card-header">
            <button class='ba-btn ba-btn-normal ba-md ba-rounded'>
              <builderall-icon :code="card.icon" style="builderall-icon{
                --builderall-icon-size: 50px;
                --builderall-icon-color: #0080FC;
              }"/>
            </button>
            <span class='earning-title'>{{ card.title }}</span>
          </div>
          <hr class='ba-hr-row'>
          <div v-for='(val, i) in card.items'
               v-if='val.show'
               class='earnings'
          >
            <span class='symbol'>{{ val.type }}</span>
            <span class='value'>{{ val.symbol + val.value }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class='ba-card ba-w-100'>
      <div class='ba-top'>
        <div class='ba-flex ba-f-column'>
          <span class='ba-title'>My Network Activity</span>
        </div>
        <div class="ba-box-items ba-flex ba-gp-1 ba-ai-center">
          <div class="filter-group" ref="outerModal">
            <div class="cursor-pointer ba-filter-btn"
                 :class="{'active': !quickFilter.every(x => x.filter == '')}"
                 @click="showModalFilter = !showModalFilter"
            >
              <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1935_30686)"><path d="M4.82339 7.38889L1.11144 4.46444C0.407981 3.91012 0.00317039 3.07952 1.85434e-05 2.18404C6.1832e-06 2.18053 0 2.17701 0 2.1735V0.972222C0 0.436333 0.436333 0 0.972222 0H13.0278C13.5637 0 14 0.436333 14 0.972222V2.1735C14 2.27183 13.9952 2.3694 13.9856 2.46593C13.9078 3.25224 13.5176 3.96879 12.8886 4.46444L9.17661 7.38889H4.82339Z" fill="#0072E1"></path> <path d="M9.13889 11.2514C9.13889 11.5114 9.00919 11.7531 8.79366 11.8986C8.2474 12.2675 7.19387 12.9866 6.68694 13.3852L5.978 13.8915C5.87728 13.9634 5.75828 14 5.63889 14C5.5475 14 5.45611 13.9786 5.37172 13.9354C5.17767 13.8355 5.05556 13.6352 5.05556 13.4167V8.55556H9.13889V11.2514Z" fill="#0072E1"></path></g> <g clip-path="url(#clip1_1935_30686)"><path d="M19.4 10.6H16.6V13.4C16.6 13.7316 16.3312 14 16 14C15.6688 14 15.4 13.7316 15.4 13.4V10.6H12.6C12.2688 10.6 12 10.3316 12 10C12 9.6684 12.2688 9.4 12.6 9.4H15.4V6.6C15.4 6.2684 15.6688 6 16 6C16.3312 6 16.6 6.2684 16.6 6.6V9.4H19.4C19.7312 9.4 20 9.6684 20 10C20 10.3316 19.7312 10.6 19.4 10.6Z" fill="#0072E1"></path></g> <defs><clipPath id="clip0_1935_30686"><rect width="14" height="14" fill="white"></rect></clipPath> <clipPath id="clip1_1935_30686"><rect width="8" height="8" fill="white" transform="translate(12 6)"></rect></clipPath></defs></svg>
              <svg v-if="!quickFilter.every(x => x.filter == '')" @click="clearFilter()" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><g clip-path="url(#clip0_1738_188457)"><path d="M7 0C3.1339 0 0 3.1339 0 7C0 10.8661 3.1339 14 7 14C10.8661 14 14 10.8661 14 7C14 3.1339 10.8661 0 7 0ZM9.64635 8.90365C9.85145 9.10875 9.85145 9.4409 9.64635 9.646C9.5438 9.7489 9.4094 9.8 9.275 9.8C9.1406 9.8 9.0062 9.7489 8.90365 9.64635L7 7.74235L5.09635 9.646C4.9938 9.7489 4.8594 9.8 4.725 9.8C4.5906 9.8 4.4562 9.7489 4.35365 9.64635C4.14855 9.44125 4.14855 9.1091 4.35365 8.904L6.25765 7L4.354 5.09635C4.1489 4.89125 4.1489 4.5591 4.354 4.354C4.5591 4.1489 4.89125 4.1489 5.09635 4.354L7 6.25765L8.90365 4.354C9.10875 4.1489 9.4409 4.1489 9.646 4.354C9.8511 4.5591 9.8511 4.89125 9.646 5.09635L7.74235 7L9.64635 8.90365Z" fill="white"></path></g> <defs><clipPath id="clip0_1738_188457"><rect width="14" height="14" fill="white"></rect></clipPath></defs></svg>
            </div>
            <transition name="fade">
            <div v-show="showModalFilter"
                 class="filter-modal ba-card ba-300"
            >
              <div class='ba-top'>
                <span class='ba-title'>Title</span>
              </div>
              <div class='ba-filter-content'>
                <span v-for="(filter, i) in quickFilter"
                      @click="openFilterSelect(i)"
                      class="filter cursor-pointer ba-flex ba-ai-center"
                      :class="{'active': filter.showFilter}"
                      :key="i"
                      ref="innerModal"
                >
                  {{ filter.title }}
                  <transition name="fade">
                  <div v-if="filter.showFilter"
                       class="filter-modal ba-card ba-300">
                    <div class='ba-top'>
                      <span class='ba-title'>{{ filter.title }}</span>
                    </div>
                    <div class="ba-filter-select ba-w-100">
                      <div class="ba-w-100">
                        <span>{{ filter.title }}</span>
                      <select class='ba-select ba-md ba-w-100' v-model="filter.filter" :id='filter.filter'>
                          <option v-for="x in filter.select"
                                  :value="x.value"
                                  :key="x.value"
                          >{{ x.title }}</option>
                      </select>
                      </div>
                      <button class='ba-btn ba-md ba-blue' @click="dispatchRequest()">
                          Apply
                      </button>
                    </div>
                  </div>
                  </transition>
                </span>
              </div>
            </div>
            </transition>
          </div>
          <span v-if="totalPage > 1" class="items-counter">{{ currentPage }} of {{ totalPage }}</span>
          <div v-if="totalPage > 1 || searchValue.length > 0" class='ba-box-search-input ba-md'>
            <input type='search' class='ba-input' placeholder='Search...' v-model="searchValue" @keyup.enter="requestTable(true)" />
            <button class='ba-button'>
              <builderall-icon code='search' />
            </button>
          </div>
        </div>
      </div>

      <div class="filter-badges">
        <div v-for="(b, i) in quickFilter"
             v-if="b.filter"
             class="ba-badge ba-md"
        >
          <span>{{ b.title }}: {{ b.select[getSelectIndex(b)].title }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none" @click="clearFilter(b.filter)">
            <g clip-path="url(#clip0_1538_8753)">
              <path d="M0.750175 0.500211C0.941978 0.500211 1.13381 0.573309 1.28042 0.719927L4.5 3.9395L7.71957 0.719927C8.01281 0.426691 8.48684 0.426691 8.78007 0.719927C9.07331 1.01316 9.07331 1.48719 8.78007 1.78042L5.5605 5L8.78007 8.21958C9.07331 8.51281 9.07331 8.98684 8.78007 9.28007C8.63383 9.42632 8.44181 9.49979 8.24982 9.49979C8.05783 9.49979 7.86582 9.42632 7.71957 9.28007L4.5 6.0605L1.28042 9.28007C1.13418 9.42632 0.942166 9.49979 0.750175 9.49979C0.558184 9.49979 0.36617 9.42632 0.219927 9.28007C-0.0733091 8.98684 -0.0733091 8.51281 0.219927 8.21958L3.4395 5L0.219927 1.78042C-0.0733091 1.48719 -0.0733091 1.01316 0.219927 0.719927C0.366545 0.573309 0.558371 0.500211 0.750175 0.500211Z" fill="#0072E1"/>
            </g>
            <defs>
              <clipPath id="clip0_1538_8753">
                <rect width="9.00021" height="9" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

      <builderall-loader class="ba-w-100" :loading='loading'>
        <table class='ba-table ba-md ba-lines-all ba-w-100' v-show="!IsEmpty(dataTable) || loading">
          <thead>
            <tr>
              <th>{{ t.label_date }}</th>
              <th>{{ t.ush_url_name }}</th>
              <th>{{ t.consent_type }}</th>
              <th>{{ t['plan-value'] }}</th>
              <th>{{ t.commission_value }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="!IsEmpty(dataTable[getDataPageIndex()])">
            <tr v-for="(item, i) in dataTable[getDataPageIndex()].data">
              <td>
                <div class='ba-subtitle'>{{ item.data.date_html }}</div>
              </td>
              <td class="ba-double">
                <div class="ba-subtitle">{{ item.data.client.name }}</div>
                <div class="ba-subtitle">{{ item.data.client.id }}</div>
                <div class="ba-subtitle">1st payment: {{ item.data.client.first_payment }}</div>
              </td>
              <td>
                <div class='ba-subtitle ba-table-badge' :class="item.data.label_values.type.title">{{ item.data.label_values.title }}</div>
              </td>
              <td>
                <div class='ba-subtitle'>{{ item.currency + ' ' + currencySymbol(item.currency) + item.valor_pago }}</div>
              </td>
              <td class='ba-double'>
                <div class='ba-subtitle'>{{ item.currency + ' ' + currencySymbol(item.currency) + item.valor }}</div>
                <div class='ba-subtitle'>{{ item.meio_pagamento }}</div>
              </td>
              <td class="status-btn" :class="item.data.status.class">
                <button ba-tooltip-position='bottom'
                        :ba-tooltip-title='getTooltipData(item)'
                        class='ba-btn ba-btn-normal ba-md ba-rounded'>
                  <builderall-icon :code="item.data.status.icon" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <nav class='ba-pagination ba-md' v-if="!IsEmpty(dataTable)">
          <ul class='ba-list ba-jc-center'>
            <li class='ba-nav-item'
                v-if="currentPage > 1"
                @click="() => currentPage--"
            >
              <a class='ba-back' href='#'>
                <span class='ba-icon'>
                    <builderall-icon code='arrow-left' />
                </span>
              </a>
            </li>
            <li class='ba-nav-item'
                v-for="page in pagesList.firstTwoPages"
                :key="page"
                @click="currentPage = page"
            >
              <a :class="['ba-link', currentPage == page ? 'ba-is-active' : '']">{{ page }}</a>
            </li>
            <span v-if="!pagesList.isInLastFour || totalPage > 4">...</span>
            <li class='ba-nav-item'
                v-for="page in pagesList.lastTwoPages"
                :key="page"
                @click="currentPage = page"
            >
              <a :class="['ba-link', currentPage == page ? 'ba-is-active' : '']">{{ page }}</a>
            </li>
            <li class='ba-nav-item'
                v-if="currentPage < totalPage"
                @click="() => currentPage++"
            >
              <a class='ba-next' href='#'>
                <span class='ba-icon'>
                    <builderall-icon code='arrow-right' />
                </span>
              </a>
            </li>
          </ul>
        </nav>

        <builderall-empty-image v-if="IsEmpty(dataTable) && !loading" size="100%"></builderall-empty-image>
      </builderall-loader>
    </div>
  </div>
</template>

<style scoped lang="scss">
.franchise-grid {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: max-content;
  gap: 1rem;
  .ba-content {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 30px;
    .ba-card {
      position: relative;
      .card-header {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        &:hover {
          .ba-btn {
            background-color: #e0e7ef!important;
          }
        }
      }
      &::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 100%;
        background: #C4D1E0;
        top: 0;
        left: calc(100% + 15px);
      }
      &:last-child::after {
        visibility: hidden;
      }
      span {
        color: #4D5D71;
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        letter-spacing: 0.66px;
      }
      .earning-title {
        color: #54779E;
        font-weight: 500;
        line-height: 18px;
      }
      .earnings {
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
        position: relative;
        .value {
          font-weight: 700;
        }
        .symbol {
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 500;
        }
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 1px;
          background: #4d5d7124;
          top: calc(100% + 8px);
        }
        &:last-child::after {
          visibility: hidden;
        }
      }
    }
  }
}
.filter-group {
  position: relative;
  .ba-filter-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background-color: #F2F9FF;
    border-radius: 6px;
    padding: 6.4px 12.8px;

    transition: all 0.3s ease-in-out;

    svg, path {
      fill: #0080FC;
    }
    &:hover, &.active {
      background-color: #0080FC;
      svg, path {
        fill: #FFF !important;
      }
    }
  }
  .filter-modal {
    position: absolute;
    background-color: #FFF;
    box-shadow: 0px 0px 8px -1px rgba(24, 39, 75, 0.12), 0px 0px 8px 5px rgba(24, 39, 75, 0.08);
    z-index: 2;
    left: -250px;
    top: 2rem;
    .ba-filter-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 5px;
      span {
        width: 100%;
        height: 2rem;
        position: relative;
        .filter-modal {
          cursor: normal;
          top: 0px;
          left: 160px;
          .ba-filter-select {
            span {
              color: #111827;
              font-family: Montserrat;
              font-size: 14px;
              font-weight: 500;
              line-height: 21px;
            }
            display: flex;
            flex-direction: column;
            gap: 20px;
            align-items: flex-end
          }
        }
      }
      .filter.active, .filter:hover {
        background-color: #F8FAFD;
        color: #0072E1;
      }
    }
  }
}
.items-counter {
  color: #4D5D71;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.66px;
}
.ba-table {
  .ba-table-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 12px;
    width: 100%;
    height: 22px;

    background-color: #EFF2F8;
    color: #4D5D71;
    &.direct-sale {
      color: #18CA9D;
      background-color: #E5FCF6;
    }
    &.level {
      color: #0072E1;
      background-color: #E5F2FF;
    }
  }
  .status-btn {
    &:hover {
      .ba-btn {
        background-color: #e0e7ef!important;
      }
    }
    builderall-icon{
      --builderall-icon-size: 20px;
      --builderall-icon-color: #0072E1;
    }
    &.waiting-release {
      builderall-icon{
        --builderall-icon-color: #FFCD44;
      }
      .ba-btn {
        background-color: #FFF6E5 !important;
      }
      &:hover {
        .ba-btn {
          background-color: #FFF6E5 !important;
        }
      }
    }
    &.available, &.balance {
      builderall-icon{
        --builderall-icon-color: #0072E1;
      }
      .ba-btn {
        background-color: #D4DFF5 !important;
      }
      &:hover {
        .ba-btn {
          background-color: #D4DFF5 !important;
        }
      }
    }
    &.refund, &.refaund {
      builderall-icon{
        --builderall-icon-color: #FA4B57;
      }
      .ba-btn {
        background-color: #FEE0E2 !important;
      }
      &:hover {
        .ba-btn {
          background-color: #FEE0E2 !important;
        }
      }
    }
    &.requested {
      builderall-icon{
        --builderall-icon-color: #8428FB;
      }
      .ba-btn {
        background-color: #F0E5FF !important;
      }
      &:hover {
        .ba-btn {
          background-color: #F0E5FF !important;
        }
      }
    }
    &.payment-pending {
      builderall-icon{
        --builderall-icon-color: #425E7D;
      }
      .ba-btn {
        background-color: #D3D3D3 !important;
      }
      &:hover {
        .ba-btn {
          background-color: #D3D3D3 !important;
        }
      }
    }
    &.paid {
      builderall-icon{
        --builderall-icon-color: #18CA9D;
      }
      .ba-btn {
        background-color: #E5FCF6 !important;
      }
      &:hover {
        .ba-btn {
          background-color: #E5FCF6 !important;
        }
      }
    }
  }
}
.filter-badges {
  width: 100%;
  display: inline-flex;
  gap: 5px;
  .ba-badge {
    background: #F2F9FF;
    color: #0072E1;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores do Vue */ {
  opacity: 0;
}

button.btn-current-earnings
{
  z-index: 1;
  &:disabled {
    filter: opacity(.9) !important;
  }
}

</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/franchise-system/earn/franchise-earn.vue